import { FC } from 'react';
import { DataContentBaseProps } from './DataContent.types';

interface ContentButtonProps {
  render: () => any;
}

export const ContentCustom: FC<DataContentBaseProps<ContentButtonProps>> = ({
  data: { render },
}) => (
 render() 
);
